import { useInfiniteQuery } from 'react-query';
import { TableSettingsType } from '../../types/configTypes';
import { createFetchAPI } from '../http';

const endpoint = 'v1/statements';

const fetchStatements = createFetchAPI<
  FetchStatementParams,
  FetchStatementResponse
>(endpoint);

export const useFetchStatements = (params: FetchStatementParams) =>
  useInfiniteQuery<FetchStatementResponse>(
    [
      'fetchStatements',
      { url: `${endpoint}/${params.finance_account_id}`, ...params },
    ],
    fetchStatements,
    {
      enabled: !!params.finance_account_id,
      getNextPageParam: response =>
        response.statements.length ? response.page + 1 : undefined,
    },
  );

type FetchStatementParams = TableSettingsType & {
  finance_account_id: number;
  start_date?: string;
  end_date?: string;
  page?: number;
};

type FetchStatementResponse = {
  // later change
  bank_account_name: string;
  bank_account_number: string;
  outlets_name: string[];
  statements: Statements[];
  page: number;
};

export type Statements = {
  year: number;
  month: number;
  details: Details[];
};

export type Details = {
  reference_no: string;
  formatted_issued_date: string;
  period: string;
  period_end_date: string;
  formatted_amount: string;
  amount: number;
  transaction_count: number;
};
